export const evilWizardIdle = new Image();
evilWizardIdle.src = "assets/characterSprites/evilWizard/Idle.png";
evilWizardIdle.width = 1200/8;
evilWizardIdle.height = 150/1;
evilWizardIdle.yOffset = 38
evilWizardIdle.xOffset = 150
evilWizardIdle.cycleLoop = [0, 0, 1, 1, 2, 2, 3, 3];